// REACT
import React from "react";

// MATERIAL-UI
import { Grid, Typography } from "@mui/material";

// COMPONENTS

// ASSESTS
import { SectorSelectionProps } from "./types";
import { FilterModalStyles } from "./styles/FilterModal.styles";
import { trackEvent } from "src/Amplitude";
const SectorSelection = (props: SectorSelectionProps) => {
  const classes = FilterModalStyles();

  // select ative styles corresponding to props.selection
  const activeStyles = {
    [props.selection]: `${classes.selectorActive} ${classes.selectorActiveBorder}`,
  };

  return (
    <Grid container justifyContent="space-around">
      {props.selectors.map((selector) => (
        <Grid key={selector} item xs={5} container justifyContent="space-around">
          <Grid
            item
            xs={8}
            onClick={() => trackEvent(`Select_Markets_Page_Select_Sector_Modal`, { selector })}>
            <Typography
              sx={{ whiteSpace: "nowrap" }}
              align="center"
              className={`${classes.selector} ${activeStyles[selector]}`}
              onClick={() => props.onClick(selector)}>
              {selector}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default SectorSelection;
